import { Injectable, } from '@angular/core';
import { NavigationNode, User } from '../models';
import { Observable } from 'rxjs/Observable';
import * as fromStore from '../store/reducers';
import * as fromStoreSelectors from '../store/selectors';
import { Store } from '@ngrx/store';
import 'rxjs/add/observable/of';

@Injectable()
export class NavigationService {
  constructor(private store: Store<fromStore.State>) { }
  //user: User;
  getNodes(): Observable<NavigationNode[]> {

    // this.store.select(fromStoreSelectors.selectLoggedInUser).subscribe(user => this.user = user);
    // TODO: This should be connverted to JSON or fetched from the DB

    var nodes = [
      { title: 'Dashboard', url: '/dashboard', icon: 'dashboard', tooltip: 'Dashboard' },
      { title: 'Tenant Management', url: '/tenants', icon: 'business', tooltip: 'Tenant Management', permissions: ['Manage All Tenants'] },
      { title: 'My Company', url: '/tenants/MyCompany', icon: 'business', tooltip: 'My Company Information', permissions: ['Update Tenant'] },
      {
        title: 'Meeting Room', icon: 'today', tooltip: 'Meeting Rooms', permissions: ['Show Meeting Rooms Menu'],
        children: [
          { title: 'My Requests', url: '/venues/my-venue-requests', icon: 'list', tooltip: 'Meeting Rooms Requests' },

          { title: 'Book a Meeting Room', url: '/venues/list', icon: 'book', tooltip: 'View/Book/Manage Current Meeting Rooms' },

        ]
      },
      {
        title: 'Access Cards',
        icon: 'assignment_ind',
        tooltip: 'Access Cards',
        permissions: ['Show Access card Menu'],
        children: [
          { title: 'My Requests', url: '/access-card/requests', icon: 'list', tooltip: 'Request Access Card' },
          { title: 'Requset an Access Card ', url: '/access-card/new', icon: 'credit_card', tooltip: 'Request Access Card' },
        { title: 'My Cards', url: '/access-card/access-card-list/', icon: 'assignment', tooltip: 'Access Cards' },
        ]
      },
      {
        title: 'Service Request',
        icon: 'build',
        tooltip: 'Service Request',
        permissions: ['Show Service Request Menu'],
        children: [
          { title: 'My Requests', url: '/facility-and-maintenance/all-requests', icon: 'list', tooltip: 'All Requests' },

          { title: 'General FM Request', url: '/facility-and-maintenance/general-request', icon: 'event_note', tooltip: 'General Request' },
          { title: 'Special FM Request', url: '/facility-and-maintenance/special-request', icon: 'chrome_reader_mode', tooltip: 'Special Request' },
          {
            title: 'Hazard Delivery Request', url: '/facility-and-maintenance/hazard-delivery-request', icon: 'local_car_wash', tooltip: 'Material Delivery Request'
          },
          {
            title: 'General Delivery Request', url: '/facility-and-maintenance/general-delivery-request', icon: 'directions_car', tooltip: 'Material Delivery Request'
          },
          { title: 'Register HAZMAT', url: '/facility-and-maintenance/register-hazard-material', icon: 'warning', tooltip: 'Material Delivery Request' }
        ]
      },
      {
        title: 'Events', icon: 'event_note', tooltip: 'Event Request', permissions: ['Show Event Menu'],
       children: [
          { title: 'My Requests', url: '/event/event-list', icon: 'list', tooltip: 'Events Requests' },
          { title: 'Requset an Event', url: '/event/requester', icon: 'date_range', tooltip: 'Request Event' },

          { title: 'Pending Events Feedback', url: '/event/acknowledgement', icon: 'event_note', tooltip: 'Events Feedback', permissions: ['Acknowledge Event Request (Security)', 'Acknowledge Event Request (Safety)', 'Acknowledge Event Request (FM)'] },
          { title: 'All Events Report', url: '/event/All-Event-reports', icon: 'description', tooltip: 'All Events Report', permissions: ['no one'] },
          { title: 'Statisticals Events Report', url: '/event/statisticals-Event-reports', icon: 'description', tooltip: 'Statisticals Events Report', permissions: ['no one'] },

        ]
      },

      {
        title: 'Announcements', icon: 'announcement', tooltip: 'Announcements', permissions: ['Show Announcement Menu'],

                children: [
                  { title: 'My Requests', url: '/announcement/announcement-list', icon: 'list', tooltip: 'Announcement Requests' },
                  { title: 'Requset an Announcement', url: '/announcement/add-announcement', icon: 'public', tooltip: 'Request an Announcement' },
                  { title: 'Feedback List', url: '/announcement/feedback-list', icon: 'wb_incandescent', tooltip: 'Feedback List' },

          ]


      },
    
      {
        title: 'Suppliers', icon: 'card_travel', tooltip: 'Suppliers', permissions: ['Approve Supplier Request','Confirm & Push Anouncement Supplier Request'],

        children: [
          { title: 'My Requests', url: '/supplier/supplier-list', icon: 'list', tooltip: 'Supplier Requests' },
        ]
      },
       {
         title: 'Invoice', icon: 'account_balance_wallet', tooltip: 'Invoice Request', permissions: [ 'Submit New Charges (TSD)', 'Confirm Misc Charges (Tenant)', 'Upload Invoices'],
         children: [
           { title: 'SO List', url: '/invoice/so-list', icon: 'list', tooltip: 'SO List', permissions: ['Upload Invoices','Submit New Charges (TSD)','Confirm Misc Charges (Tenant)']},
           { title: 'Add Charges', url: '/invoice/add-charges', icon: 'add_circle', tooltip: 'add charges', permissions: ['Submit New Charges (TSD)'] },

           { title: 'All Charges', url: '/invoice/charges-list', icon: 'monetization_on', tooltip: 'All charges' },

           { title: 'Manage Invoices', url: '/invoice/upload-invoice-list', icon: 'device_hub', tooltip: 'Manage Invoice', permissions: ['Upload Invoices']},

        ]
      },
      {
        title: 'Administration', icon: 'settings', tooltip: 'Administration',
        permissions: ['Manage All Users', 'Manage Tenant Users', 'Manage Roles'],
        children: [
          { title: 'Users', url: '/admin/users', icon: 'supervisor_account', tooltip: 'Users', permissions: ['Manage All Users', 'Manage Tenant Users'] },
          { title: 'Roles', url: '/admin/roles', icon: 'people_outline', tooltip: 'Roles', permissions: ['Manage Roles'] },
          { title: 'Rooms Layout', url: '/admin/layout', icon: 'people_outline', tooltip: 'Rooms Layout', permissions: ['Manage Rooms Layout'] },
          { title: 'Resource Center', url: '/admin/resource-center', icon: 'attachment', tooltip: 'Resource Center', permissions: ['Manage Resource Center'] },
          { title: 'Tenant Requests Report', url: '/admin/tenants-requests-report', icon: 'list', tooltip: 'Tenant Requests Report', permissions: ['View Tenant Requests Report (TSD)'] },

        ]
      },
      { title: 'Support & Feedback', url: '', icon: 'help_outline', tooltip: 'Invoices', permissions: ['no one'] },
      { title: 'Feedback', url: '/feedbacks-list', icon: 'wb_incandescent', tooltip: 'Feedback List', permissions: ['View All Feedbacks (TSD)'] },
      {
        title: 'Directory', icon: 'view_list', tooltip: 'Directory',
        children: [
          { title: 'Tenants', url: '/tenants/tenants-directory', icon: 'business', tooltip: 'Tenants Directory' },

          { title: 'Suppliers', url: '/supplier/supplier-directory', icon: 'card_travel', tooltip: 'Suppliers Directory' },

        ]
      }

    ];

    return Observable.of(nodes as NavigationNode[]);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/navigation.service.ts